import axios from "@/libs/axios";

const endpointPrefix = process.env.VUE_APP_API_PREFIX;

export default {
  categories() {
    return axios.get(`/${endpointPrefix}/categories`);
  }
}
